import { InboxEntry } from './inbox-entry.model';

export interface TestlaufZiel {
  projectId: string;
  runId: string;
}

const TESTLAUF_SEITE = /^\/projects\/([^/?#]+)\/test-runs\/([^/?#]+)$/;

export function inboxTargetUrl(entry: InboxEntry): string {
  const params = entry.params ?? {};
  const query = Object.keys(params)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(String(params[key]))}`)
    .join('&');
  return query ? `${entry.page}?${query}` : entry.page;
}

export function testlaufZiel(entry: InboxEntry): TestlaufZiel | null {
  if (entry.entityType !== 'testrun') return null;
  const treffer = TESTLAUF_SEITE.exec(entry.page ?? '');
  return treffer ? { projectId: treffer[1], runId: treffer[2] } : null;
}
